import styled from 'styled-components';

export const CmsSidebar = styled.div`
  > * {
    &:not(:first-child) {
      margin-top: 40px;
    }
  }
`;
